import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { DateShort, money } from "utils/helpers";
import { PaymentTypeOptions, RentalOptions } from "utils/Constant";

/**
 * Exports the Rental Order list to a PDF file.
 * @param {Array} listData - array of rental order rows (same shape as rentalOrderList?.data?.listData)
 * @param {Object} meta - { totalAmount, dateFrom, dateTo }
 */
export function exportRentalOrderToPdf(listData = [], meta = {}) {
    const { totalAmount = 0, dateFrom, dateTo } = meta;

    const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });

    doc.setFontSize(14);
    doc.text("Laporan Rental", 40, 40);

    doc.setFontSize(10);
    if (dateFrom && dateTo) {
        doc.text(`Periode: ${DateShort(dateFrom)} - ${DateShort(dateTo)}`, 40, 58);
    }

    const columns = [
        { header: "No", dataKey: "rowNumber" },
        { header: "Tanggal", dataKey: "orderDate" },
        { header: "Pelanggan", dataKey: "customerName" },
        { header: "Item", dataKey: "item" },
        { header: "Durasi", dataKey: "duration" },
        { header: "Jumlah", dataKey: "nettAmount" },
        { header: "Metode Pembayaran", dataKey: "paymentType" },
        { header: "Status", dataKey: "status" },
    ];

    const rows = listData.map((row, i) => ({
        rowNumber: i + 1,
        orderDate: DateShort(row.rentalDate),
        customerName: row.customerName,
        item: `${row.brandName} ${row.productName}`,
        duration: `${row.quantity} ${RentalOptions.find((x) => x.value === String(row.rentalOptions))?.label ?? ""}`,
        nettAmount: `Rp ${money(row.nettAmount)}`,
        paymentType:
            PaymentTypeOptions.find((x) => x.value === String(row.paymentType))?.label ?? "-",
        status: row.status ? "Active" : "Inactive",
    }));

    autoTable(doc, {
        startY: 72,
        columns,
        body: rows,
        styles: { fontSize: 8, cellPadding: 4 },
        headStyles: { fillColor: [30, 30, 30], textColor: 255 },
        foot: [
            [
                { content: "Total", colSpan: 5, styles: { halign: "right", fontStyle: "bold" } },
                { content: `Rp ${money(String(totalAmount))}`, styles: { fontStyle: "bold" } },
                "",
                "",
            ],
        ],
        showFoot: "lastPage",
    });

    const fileName = `rental-order-${new Date().toISOString().slice(0, 10)}.pdf`;
    doc.save(fileName);
}